export const Cadastro = ({ data, setData, optionsUndadm, insertOrUpdate }) => {
  return (
    <div className="row">
      <div className="col-12">
        <div className="col-12 row">
          <div className="col-3 col-md-2">
            <span className="col-form-label">Cód. da Pergunta</span>
          </div>
          <div className="col-9 col-md-10">
            <span className="col-form-label">Descrição da Pergunta</span>
          </div>
        </div>
        <div className="col-12 row">
          <div className="col-3 col-md-2">
            <input
              type="text"
              className="form-control form-control-sm border border-dark"
              value={data?.id || ''}
              disabled
            />
          </div>
          <div className="col-9 col-md-10">
            <input
              type="text"
              className="form-control form-control-sm border border-dark"
              value={data?.descricao || ''}
              onChange={(e) => setData({ ...data, descricao: e.target.value })}
              disabled={insertOrUpdate === 'read' && true}
              maxLength={100}
              style={{ textTransform: 'uppercase' }}
            />
          </div>
        </div>
      </div>

      <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <div className="col-12 row">
          <div className="col-12">
            <span className="col-form-label">Abreviatura</span>
          </div>
        </div>
        <div className="col-12 row">
          <div className="col-12">
            <input
              type="text"
              className="form-control form-control-sm border border-dark"
              value={data?.abreviacao || ''}
              onChange={(e) => setData({ ...data, abreviacao: e.target.value })}
              disabled={insertOrUpdate === 'read' && true}
              maxLength={30}
              style={{ textTransform: 'uppercase' }}
            />
          </div>
        </div>

        <div className="col-12 row">
          <div className="col-12">
            <span className="col-form-label">Palavra Chave</span>
          </div>
        </div>
        <div className="col-12 row">
          <div className="col-12">
            <input
              type="text"
              className="form-control form-control-sm border border-dark"
              value={data?.palavraChave || ''}
              onChange={(e) =>
                setData({ ...data, palavraChave: e.target.value })
              }
              disabled={insertOrUpdate === 'read' && true}
              maxLength={30}
              style={{ textTransform: 'uppercase' }}
            />
          </div>
        </div>

        <div className="col-12 row">
          <div className="col-6 col-md-4">
            <span className="col-form-label">Relevância</span>
          </div>
          <div className="col-6 col-md-4">
            <span className="col-form-label">Múltipla Resposta</span>
          </div>
        </div>
        <div className="col-12 row">
          <div className="col-6 col-md-4">
            <select
              className="form-select form-select-sm border border-dark"
              value={data?.relevancia || ''}
              onChange={(e) => setData({ ...data, relevancia: e.target.value })}
              disabled={insertOrUpdate === 'read' && true}
            >
              <option defaultValue></option>
              <option value="BAIXA">BAIXA</option>
              <option value="MEDIA">MEDIA</option>
              <option value="ALTA">ALTA</option>
            </select>
          </div>
          <div className="col-6 col-md-4">
            <select
              className="form-select form-select-sm border border-dark"
              value={data?.multiplaResposta || ''}
              onChange={(e) =>
                setData({ ...data, multiplaResposta: e.target.value })
              }
              disabled={insertOrUpdate === 'read' && true}
            >
              <option defaultValue></option>
              <option value="SIM">SIM</option>
              <option value="NAO">NAO</option>
            </select>
          </div>
        </div>
      </div>

      <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <div className="col-12 row">
          <div className="col-6 col-md-3">
            <span className="col-form-label">Usuário</span>
          </div>
        </div>
        <div className="col-12 row">
          <div className="col-6 col-md-3">
            <input
              type="text"
              className="form-control form-control-sm border border-dark"
              value={data?.usuario || ''}
              disabled
            />
          </div>
        </div>

        <div className="col-12 row">
          <div className="col-6 col-md-3">
            <span className="col-form-label">Dt. Inclusão</span>
          </div>
          <div className="col-6 col-md-3">
            <span className="col-form-label">Hr. Inclusão</span>
          </div>
        </div>
        <div className="col-12 row">
          <div className="col-6 col-md-3">
            <input
              type="date"
              className="form-control form-control-sm border border-dark"
              value={data?.dataInclusao || ''}
              disabled
            />
          </div>
          <div className="col-6 col-md-3">
            <input
              type="text"
              className="form-control form-control-sm border border-dark"
              value={data?.horaInclusao || ''}
              disabled
            />
          </div>
        </div>

        <div className="col-12 row">
          <div className="col-6 col-md-3">
            <span className="col-form-label">Dt. Atualização</span>
          </div>
          <div className="col-6 col-md-3">
            <span className="col-form-label">Hr. Atualização</span>
          </div>
        </div>
        <div className="col-12 row">
          <div className="col-6 col-md-3">
            <input
              type="date"
              className="form-control form-control-sm border border-dark"
              value={data?.dataAtualizacao || ''}
              disabled
            />
          </div>
          <div className="col-6 col-md-3">
            <input
              type="text"
              className="form-control form-control-sm border border-dark"
              value={data?.horaAtualizacao || ''}
              disabled
            />
          </div>
        </div>
      </div>
    </div>
  );
};
